import { Option } from "../components/shared/selectInput/types/selectInputProps";
import { Dictionary } from "./dictionariesFromLayers";

export const getSelected = (names?: (string | undefined)[]) => {
    var options: Option[] = [];
    if (names) {
        for (var i = 0; i < names?.length; i++) {
            if (names[i] !== undefined && names[i] != null) options.push({ name: names[i], value: names[i] });
        }
    }
    return options;
}

export const prepareDataForSelect = (data: any) => {
    if (data !== undefined) {
        return getSelected(data.map((value: any) => {
            if (value.nazwa) return value.nazwa;
            else return value.opis;
        }) as string[]);
    }
}

export const mockPrepareViewData = (value?: string | number) => {
    return getSelected([value?.toString()]);
}

export const prepareDataSingleForSelect = (Options?: Option[], values?: (string | undefined | null)[] | (number | undefined | null)[] | undefined | null, SingleValue?: string | number | undefined | null) => {
    var OptionsFound: Option[] = [];
    if (SingleValue) {
        var opt = Options?.find((option) => {
            return option.value === SingleValue || option.name === SingleValue;
        })
        if (opt) OptionsFound.push(opt);
    }
    if (values) {
        values.forEach((value) => {
            var opt = Options?.filter((option) => {
                return option.value === value || option.name === value;
            })
            if (opt) OptionsFound = OptionsFound.concat(opt);
        })
    }
    return OptionsFound;
}

export const getSingleSelectedOption = (name?: string, dictionaries?: Dictionary) => {

}

export const GetOptions = (name?: string, dictionaries?: Dictionary, sortByOrder?: boolean, unique?: boolean) => {
    if (dictionaries && name) {
        var dict = dictionaries[name];
        if (sortByOrder && dict !== undefined) {
            dict.sort((a, b) => a.anothers.KOLEJNOSC - b.anothers.KOLEJNOSC);
        }
        if (unique) {
            return hideUniqueByAlias(dict);
        }
        return dict;
    }
}

const hideUniqueByAlias = (dic: Option[]) => {
    const names = new Set();
    const unique = dic?.map(item => {
        const duplicate = names.has(item.name);
        names.add(item.name);
        if (duplicate) {
            return { ...item, hide: true }
        }
        return item;
    });
    return unique;
}

export const toSelected = (gidKey: string, Options?: Option[], values?: any[] | undefined | undefined | null) => {
    const OptionsFound: Option[] = [];
    if (values) {
        const sorted = [...values].sort((a, b) => a.kolejnosc! - b.kolejnosc!);
        sorted.forEach((value) => {
            const opt = Options?.find((option) => {
                return option.anothers?.GLOBALID === value[gidKey];
            })
            if (opt) {
                OptionsFound.push(opt);
            }
        })
    }
    return OptionsFound;
}